import React from "react";
import { FaTrash } from "react-icons/fa";
import { SortableContainer, SortableElement, SortableElementProps, SortableHandle } from "react-sortable-hoc";
import ActionConfirmationButton from "../../../../../pages/CourseAuthor/ActionConfirmation";
import { HTMLContent } from "../../../../html-editor/HTMLContent";
import { IListItem } from "../../../../types";
import { AnswerItem } from "../answer-item/AnswerItem";
import { ListItemNumber, ListItemOptions, ListItemsContainer } from "../list-items/ListItemsExercisePart.styles";
import { AnswerContainer, DragBars } from "./OrderItems.styles";
import { IOrderItemsProps } from "./OrderItems.types";

interface ISortableOrderItemProps extends IOrderItemsProps, SortableElementProps {
  orderItem: IListItem;
}

const SortBars = SortableHandle(() => <DragBars />);

export const SortableOrderItem = SortableElement((props: ISortableOrderItemProps) => {
  const { currentLocale, index, isEditing, orderItem, partOperations } = props;
  const placeholder = "No text available.";
  const localizedAnswer = orderItem.text.elems.find(t => t.locale === currentLocale);
  const localizedHint = orderItem.hint.elems.find(h => h.locale === currentLocale);

  return (
    <ListItemsContainer>
      <ListItemNumber>{index + 1}.</ListItemNumber>
      <AnswerItem
        localizedHint={localizedHint}
        modifyExerciseItemHint={partOperations.modifyExerciseItemHint(orderItem.id)}
        currentLocale={currentLocale}
        isEditing={isEditing}
      >
        <AnswerContainer isEditing={isEditing}>
          <HTMLContent
            content={(localizedAnswer && localizedAnswer.value.text) || (!isEditing ? placeholder : "")}
            disabled={!isEditing}
            locale={currentLocale}
            onSubmit={partOperations.modifyExerciseItemText(orderItem.id)}
            placeholder={placeholder}
          />
          {isEditing && (
            <ListItemOptions>
              <SortBars />
              <ActionConfirmationButton
                ActionIcon={FaTrash}
                action="Delete"
                actionFn={partOperations.deleteExerciseItem(orderItem.id)}
              />
            </ListItemOptions>
          )}
        </AnswerContainer>
      </AnswerItem>
    </ListItemsContainer>
  );
});

export const SortableOrderItemList = SortableContainer((props: IOrderItemsProps) => {
  const { currentLocale, exercisePart } = props;
  const exercises: IListItem[] = props.exercisePart.content.items.elems
    .map<IListItem>((item, index) => ({ ...item, sort: index }))
    .filter(item => !item.deleted);

  return (
    <div>
      {exercises.map(orderItem => (
        <SortableOrderItem
          {...props}
          index={orderItem.sort}
          key={`${exercisePart.id}-${currentLocale}-${orderItem.id}`}
          orderItem={orderItem}
        />
      ))}
    </div>
  );
});
